module.exports = __webpack_public_path__ + "static/img/高級編輯02.1065330.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serviceContent/高級編輯02.jpg
// module id = 5fRz
// module chunks = 1